import {
  BreakpointsOptions,
  createTheme,
  PaletteOptions,
} from '@mui/material/styles';
import { TypographyOptions } from '@mui/material/styles/createTypography';
import { pxToEm } from './util/pxToEm';

export const FULL_WIDTH = 1672;

export enum ThemeColor {
  Black = '#000',
  Grey = '#E8EAEE',
}

declare module '@mui/material/styles' {
  interface Palette {
    vibrant: {
      primary: string;
      secondary: string;
    };

    tempered: {
      light: string;
      dark: string;
    };

    neutral: {
      lightest: string;
      light: string;
      main: string;
      dark: string;
      darker: string;
      darkest: string;
    };
  }

  interface PaletteOptions {
    vibrant: {
      primary: string;
      secondary: string;
    };

    tempered: {
      light: string;
      dark: string;
    };

    neutral: {
      lightest: string;
      light: string;
      main: string;
      dark: string;
      darker: string;
      darkest: string;
    };
  }
}

const palette = {
  background: {
    default: '#fcfcff',
  },
  primary: {
    main: '#24305F',
  },
  vibrant: {
    primary: '#ffe733',
    secondary: '#5CDA64',
  },
  tempered: {
    light: '#fffbde',
    dark: '#fce65b',
  },
  neutral: {
    lightest: '#fcfcff',
    light: '#f7f7f7',
    main: '#efefef',
    dark: '#dedede',
    darker: '#b9b9b9',
    darkest: '#777',
  },
  text: {
    primary: '#383838', // Dark-gray
    secondary: '#b9b9b9', // Light-gray
  },
  error: {
    main: '#9b0000',
    light: '#bf271b',
  },
  success: {
    main: '#1e8000',
  },
};

palette as PaletteOptions;

const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 992,
    lg: 1300,
    xl: 1672,
  },
};

breakpoints as BreakpointsOptions;

const typography = {
  fontFamily: 'Poppins',
  fontSize: 16,
  h1: {
    fontSize: pxToEm(30),
    fontWeight: 700,
    color: palette.primary.main,
  },
  h2: {
    fontSize: pxToEm(25),
    fontWeight: 600,
  },
  h3: {
    fontSize: pxToEm(20),
    fontWeight: 600,
  },
  h4: {
    fontSize: pxToEm(14),
    fontWeight: 700,
  },
  body1: {
    fontSize: 'inherit',
    fontWeight: 400,
  },
};

typography as TypographyOptions;

export const theme = createTheme({
  palette,
  breakpoints,
  typography,
  spacing: 1,
  shape: {
    borderRadius: 1,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          lineHeight: 1.5,
        },
      },
    },
  },
});
